// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"bbc95140","453":"7969a5d1","777":"6b325c99"}[chunkId] + ".chunk.js";
};